var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _g, _circle3, _circle4, _g2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnomalyError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2495_312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 224,
    height: 224
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 112,
    r: 112,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2495_312)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 112,
    r: 112,
    fill: "#8CD1FC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.9058,
    y: 42.6997,
    width: 100.681,
    height: 136.216,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.1582,
    y: 135.682,
    width: 78.1759,
    height: 5.92242,
    rx: 2.96121,
    fill: "#E8E8E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70.1582,
    y: 153.449,
    width: 78.1759,
    height: 5.92242,
    rx: 2.96121,
    fill: "#E8E8E8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70.1582,
    y: 117.915,
    width: 78.1759,
    height: 5.92242,
    rx: 2.96121,
    fill: "#E8E8E8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70.1582,
    y: 100.147,
    width: 78.1759,
    height: 5.92242,
    rx: 2.96121,
    fill: "#E8E8E8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70.1582,
    y: 82.3798,
    width: 78.1759,
    height: 5.92242,
    rx: 2.96121,
    fill: "#E8E8E8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70.1582,
    y: 64.6129,
    width: 78.1759,
    height: 5.92242,
    rx: 2.96121,
    fill: "#E8E8E8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 9.7655,
    height: 18.1359,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 123.137 112.833)",
    fill: "#FFC300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.886 129.109C110.944 128.015 110.929 126.274 109.853 125.197L103.867 119.212C102.791 118.135 101.05 118.12 99.9553 119.178L43.233 173.994L55.0706 185.832L109.886 129.109Z",
    fill: "#00539D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2495_312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 118,
    width: 68,
    height: 68
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.886 129.109C110.944 128.015 110.929 126.274 109.853 125.197L103.867 119.212C102.791 118.135 101.05 118.12 99.9553 119.178L43.233 173.994L55.0706 185.832L109.886 129.109Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2495_312)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.8985,
    cy: 42.8985,
    r: 42.8985,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 206 83.2394)",
    fill: "#00539D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2495_312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 48,
    width: 70,
    height: 70
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.528,
    cy: 34.528,
    r: 34.528,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 194.163 83.2393)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2495_312)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.528,
    cy: 34.528,
    r: 34.528,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 194.163 83.2393)",
    fill: "#29B8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65.5684,
    height: 108.816,
    transform: "matrix(-1 0 0 1 167.557 28.8495)",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.515 87.7763C148.515 88.3929 148.155 88.8554 147.487 88.8554H143.325C142.812 88.8554 142.349 88.4443 142.349 87.8791V83.8198C142.349 81.1932 144.417 79.4443 146.328 77.8287C147.968 76.4419 149.491 75.1532 149.491 73.4919C149.491 71.6421 147.95 70.0492 145.381 70.0492C142.95 70.0492 141.57 71.2543 140.594 72.107C140.311 72.3538 140.062 72.5712 139.831 72.7211C139.42 72.9781 139.061 72.9781 138.701 72.6698L136.286 70.3061C135.875 69.9465 135.926 69.3299 136.286 68.9702C136.286 68.9702 139.78 64.4485 146.357 64.4485C151.752 64.4485 156.325 68.0453 156.325 73.0808C156.325 76.7291 153.636 78.8558 151.414 80.6134C149.849 81.851 148.515 82.9056 148.515 84.1795V87.7763ZM149.286 97.5905C149.286 99.6972 147.487 101.444 145.381 101.444C143.274 101.444 141.578 99.6972 141.578 97.5905C141.578 95.5352 143.274 93.7368 145.381 93.7368C147.487 93.7368 149.286 95.5352 149.286 97.5905Z",
    fill: "#00559B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnomalyError);
export default __webpack_public_path__ + "static/media/anomaly_error.0a28cfbfeb59698d934cd96d2e34ad24.svg";
export { ForwardRef as ReactComponent };